import { Component } from '@angular/core';
import { FundraiserService } from 'src/app/pages/fundraiser/services/fundraiser.service';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatCardModule } from '@angular/material/card';
import { FeaturedTopicsCardComponent } from '../featured-topics-card/featured-topics-card.component';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass, NgIf } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-featured-topics',
    templateUrl: './featured-topics.component.html',
    styleUrls: ['./featured-topics.component.scss'],
    standalone: true,
    imports: [FlexModule, NgClass, ExtendedModule, NgIf, FeaturedTopicsCardComponent, MatCardModule, MatChipsModule, MatButtonModule]
})
export class FeaturedTopicsComponent {
	featuredTopicsData1: any = {};
	featuredTopicsData2: any = {};
	featuredTopicsData3: any = {};
	isLoading: boolean = true;

	constructor(public fundraiserService: FundraiserService) {}

	ngOnInit(): void {
		const locale = window.location.hostname.includes('localhost')
			? 'en'
			: window.location.pathname.split('/')[1];
		this.fundraiserService
			.getFeaturedTopics(locale || 'en')
			.subscribe((res: any) => {
				this.featuredTopicsData1 = res?.data?.results[0];
				this.featuredTopicsData2 = res?.data?.results[1];
				this.featuredTopicsData3 = res?.data?.results[2];

				this.isLoading = false;
			});
	}

	redirectToDonate(link: string): void {
		// window.open(link, '_blank');
		window.location.href = link;
	}
}
